if (!customElements.get('goodrings-sticky-atc')) {
  customElements.define(
    'goodrings-sticky-atc',
    class GoodRingsStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('.gr-sticky-atc__button');
        this.stickyButtonText = this.stickyButton?.querySelector('span');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.updateVisibility = this.updateVisibility.bind(this);
        this.handleStickyClick = this.handleStickyClick.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);

        if (!this.stickyButton) return;

        this.stickyButton.addEventListener('click', this.handleStickyClick);
        this.mobileMediaQuery.addEventListener?.('change', this.handleViewportChange);
        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        window.addEventListener('resize', this.updateVisibility, { passive: true });

        this.connectToProductButton();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleStickyClick);
        this.mobileMediaQuery?.removeEventListener?.('change', this.handleViewportChange);
        window.removeEventListener('scroll', this.updateVisibility);
        window.removeEventListener('resize', this.updateVisibility);
        this.buttonObserver?.disconnect();
        this.setVisible(false);
      }

      connectToProductButton() {
        this.buttonObserver?.disconnect();
        this.productButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.productButton) return;

        this.buttonObserver = new MutationObserver(() => {
          this.syncButtonState();
          this.updateVisibility();
        });
        this.buttonObserver.observe(this.productButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });
        this.syncButtonState();
      }

      handleViewportChange() {
        this.updateVisibility();
      }

      handleStickyClick() {
        if (!this.productButton?.isConnected) this.connectToProductButton();
        if (!this.productButton || this.isProductButtonDisabled()) return;
        this.productButton.click();
      }

      isProductButtonDisabled() {
        return (
          this.productButton.disabled ||
          this.productButton.getAttribute('aria-disabled') === 'true'
        );
      }

      syncButtonState() {
        if (!this.productButton || !this.stickyButton) return;

        const sourceText = this.productButton.querySelector('span:not(.sold-out-message):not(.svg-wrapper)');
        const soldOutText = this.productButton.querySelector('.sold-out-message:not(.hidden)');
        const label = soldOutText?.textContent.trim() || sourceText?.textContent.trim();
        if (label && this.stickyButtonText) this.stickyButtonText.textContent = label;

        const disabled = this.isProductButtonDisabled();
        this.stickyButton.disabled = disabled;
        this.stickyButton.classList.toggle('loading', this.productButton.classList.contains('loading'));
        this.stickyButton.querySelector('.loading__spinner')?.classList.toggle(
          'hidden',
          !this.productButton.classList.contains('loading')
        );
      }

      updateVisibility() {
        if (!this.mobileMediaQuery?.matches) {
          this.setVisible(false);
          return;
        }

        if (!this.productButton?.isConnected) this.connectToProductButton();
        if (!this.productButton) {
          this.setVisible(false);
          return;
        }

        const buttonBounds = this.productButton.getBoundingClientRect();
        this.setVisible(buttonBounds.bottom <= 0);
      }

      setVisible(visible) {
        this.dataset.visible = visible ? 'true' : 'false';
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('gr-sticky-atc-visible', visible);
      }
    }
  );
}
